var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-3" }, [
      _c(
        "label",
        {
          staticClass: "font-weight-bold col-form-label",
          attrs: { for: _vm.id }
        },
        [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-9 mt-1" }, [
      _c(
        "label",
        {
          staticClass: "toggle__button",
          class: { active: _vm.isActive },
          attrs: { for: _vm.id + "_button" }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.checkedValue,
                expression: "checkedValue"
              }
            ],
            attrs: {
              type: "checkbox",
              disabled: _vm.disabled,
              id: _vm.id + "_button"
            },
            domProps: {
              checked: Array.isArray(_vm.checkedValue)
                ? _vm._i(_vm.checkedValue, null) > -1
                : _vm.checkedValue
            },
            on: {
              change: function($event) {
                var $$a = _vm.checkedValue,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.checkedValue = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.checkedValue = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.checkedValue = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "toggle__switch" }),
          _vm._v(" "),
          _vm.isActive
            ? _c("span", { staticClass: "toggle__label ml-2" }, [
                _vm._v(_vm._s(_vm.enableText))
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isActive
            ? _c("span", { staticClass: "toggle__label ml-2" }, [
                _vm._v(_vm._s(_vm.disabledText))
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }